// @/services/content/store/modules/self-assessment-bs.js
export class SelfAssessmentBSHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Self Assessment Business Segments content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.selfAssessmentBS?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.selfAssessmentBS?.['en'] || null;
    }
    
    return null;
  }
}